import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPedal = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M26.212 16.5h47.576c6.211 0 11.903 5.04 11.212 11.212V58.5c0 7.056-2.744 13.091-6 18.788C75.91 82.695 72 90.5 65.788 90.5H34.212C28.001 90.5 23.97 82.762 21 77.288c-3.091-5.697-6-11.732-6-18.788V27.712C14.309 21.539 20 16.5 26.212 16.5" })
});
export default SvgPedal;
